import React, { useState } from "react";
import Img2 from "../../../assets/img/learn_img(2).png";
import img2 from "../../../assets/img/learn_img(2.1).png";
import Img3 from "../../../assets/img/learn_img(3).png";
import Img4 from "../../../assets/img/learn_img(4).png";
import img4 from "../../../assets/img/frame3.png";
import Img5 from "../../../assets/img/learn_img(5).png";
import imge5 from "../../../assets/img/learn_img(5.3).png";
import Img6 from "../../../assets/img/learn_img(6).png";
import Img7 from "../../../assets/img/learn_img(7).png";
import Img8 from "../../../assets/img/learn_img(8).png";
import Img9 from "../../../assets/img/frame2.png";
import Button from "../../../components/Button/Button";
import { useNavigate } from "react-router-dom";
import "./LearnPage.css";
import "../FamousPage/FamousPage.css";
import FavRequestModal from "../../../components/Modal/FavRequestModal/FavRequestModal";
import { FavRequest } from "../../../services/favRequest.service";
import { handleMessage } from "../../../utils/handleMessagePopup";
import { trackEvent } from "../../../utils/ga";
import { IFavRequest } from "../../../types/types";
import useAuthService from "../../../auth/AuthService";

const LearnPage: React.FC<{
  handleScrollToTop?: () => void;
}> = ({ handleScrollToTop }) => {
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuthService();
  const [state, setState] = useState({
    isPeopleOpen: false,
    isHistoricalOpen: false,
    isPlacesOpen: false,
    isThingsOpen: false,
    isFavModalOpen: false,
  });

  const toggleDropdown = (key: keyof typeof state, value?: boolean) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value
        ? value
        : typeof prevState[key] === "boolean"
          ? !prevState[key]
          : prevState[key],
    }));
  };

  const [formData, setFormData] = useState<IFavRequest>({
    favname: "",
    email: "",
  });

  const handleFavRequest = async () => {
    try {
      const response = await FavRequest(formData);
      if (response.error == null) {
        handleMessage("Request submitted successfully");
        setState((pre) => ({ ...pre, isFavModalOpen: false }));
        trackEvent(
          "submit_fav_request",
          JSON.stringify({ favname: formData.favname })
        );
      } else {
        handleMessage("Please send your request");
      }
    } catch {
      console.error("Unable to submit request");
    }
  };

  const handleToggle = (key: keyof typeof state, value?: boolean) => {
    setState((pre) => ({ ...pre, [key]: value ? value : !pre[key] }));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleClick = () => {
    if (isAuthenticated) {
      navigate("/settings/profile");
    } else {
      login();
    }
  };

  return (
    <div className="learns-page">
      <div className="container">
        <div className="d-flex flex-column text-center align-items-center">
          <h1 className="my-3 font-500-44">
            Everything you need to know about Fan1
          </h1>
          <h2 className="font-500-30 font-inter px-2">
            One fan. One connection. One moment in the spotlight.
          </h2>
          <div className="learn-img-div1 mt-5 mb-4 position-relative">
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/EkFqh98EXj4?start=0&autoplay=0&controls=0&loop=1&playlist=EkFqh98EXj4&rel=0&modestbranding=1&fs=0&showinfo=0"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>


          </div>

          <div className="col-12 d-flex flex-column flex-md-row gap-3 justify-content-center">
            <Button
              label={"Browse Available Memberships"}
              className="font-500-20 p-3 w-md-auto"
              onClick={() => {
                navigate("/available");
              }}
            />
            <Button
              label="Register to Offer a Membership"
              className="font-500-20 p-3 yellowBtn w-md-auto"
              onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}
            />
          </div>
        </div>

        <div className="fan-div-2 mt-80 bg-midnight learn-div-2 position-relative">
          <h2 className="font-500-36 fan-head1">Membership types</h2>
          <p className="font-300-15 mt-4">
            Fan1 offers exclusive, singular memberships where only one Fan1
            exists at any time. Public figures can only represent one membership
            at a time—for example, a lead singer can offer a membership
            individually but can’t also represent their band at the same time.
            Fan1 isn’t just for active public figures either. Become Fan1 to
            your favorite historical or fictional people, places, or things.
            What do you adore most?
          </p>
          <div className="mt-5 d-flex flex-column flex-md-row justify-content-between">
            <div className="mb-4 mb-md-0 me-md-3">
              <h4 className="mb-1 font-500-26 fan-head4">For Fans</h4>
              <p className="font-300-15">
                Fans have countless ways to prove their loyalty and claim their
                place as the ultimate fan.
              </p>
            </div>
            <div className="">
              <h4 className="mb-1 font-500-26 fan-head4">For Public Figures</h4>
              <p className="font-300-15">
                Give your biggest supporters what they truly want—direct
                connection with you.
              </p>
            </div>
          </div>

          <div className="d-none d-md-block mt-5">
            <table className="learn-table w-100 mt-5">
              <thead>
                <tr>
                  <th className="text-midnight">.</th>
                  <th className="learn-th">People</th>
                  <th className="learn-th">Historical/Fictional People</th>
                  <th className="learn-th">Places</th>
                  <th className="learn-th">Things</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="learn-th">One Fan1 at a time</th>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                </tr>
                <tr>
                  <th className="learn-th">Always exclusive</th>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                </tr>
                <tr>
                  <th className="learn-th">Public message board</th>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                </tr>
                <tr>
                  <th className="learn-th">Verified Public Figures</th>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td className="text-midnight">.</td>
                  <td className="text-midnight">.</td>
                  <td className="text-midnight">.</td>
                </tr>
                <tr>
                  <th className="learn-th">Private messages</th>
                  <td>
                    <svg
                      width="24"
                      height="17"
                      viewBox="0 0 24 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.5195 0.480469C23.9766 0.988281 23.9766 1.75 23.5195 2.20703L10.1133 15.6133C9.60547 16.1211 8.84375 16.1211 8.38672 15.6133L1.48047 8.70703C0.972656 8.25 0.972656 7.48828 1.48047 7.03125C1.9375 6.52344 2.69922 6.52344 3.15625 7.03125L9.19922 13.0742L21.793 0.480469C22.25 0.0234375 23.0117 0.0234375 23.4688 0.480469H23.5195Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td className="text-midnight">.</td>
                  <td className="text-midnight">.</td>
                  <td className="text-midnight">.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mem-dropdown d-block d-md-none">
            <div className="border-bottom py-2">
              <div className={`${state.isPeopleOpen && "border-bottom pb-2"} d-flex justify-content-between px-2`} onClick={() => { toggleDropdown("isPeopleOpen") }}>
                <div className="fan-heading4">
                  People
                </div>
                {state.isPeopleOpen ? <i className="fa-solid fa-angle-up"></i> : <i className="fa-solid fa-angle-down"></i>}
              </div>
              {state.isPeopleOpen && (
                <div>
                  <ul className="list-unstyled m-0">
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">One Fan1 at a time
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Always exclusive
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Public message board
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Verified Public Figures
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Private messages
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                  </ul>
                </div>
              )}{" "}
            </div>
            <div className="border-bottom py-2">
              <div className={`${state.isHistoricalOpen && "border-bottom pb-2"} d-flex justify-content-between px-2`} onClick={() => { toggleDropdown("isHistoricalOpen") }}>
                <div className="fan-heading4" >
                  Historical/Fictional People
                </div>
                {state.isHistoricalOpen ? <i className="fa-solid fa-angle-up"></i> : <i className="fa-solid fa-angle-down"></i>}
              </div>
              {state.isHistoricalOpen && (
                <div className="">
                  <ul className="list-unstyled m-0">
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">One Fan1 at a time
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Always exclusive
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Public message board
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Verified Public Figures</div> </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Private messages</div> </li>
                  </ul>
                </div>
              )}{" "}
            </div>
            <div className="border-bottom py-2">
              <div className={`${state.isPlacesOpen && "border-bottom pb-2"} d-flex justify-content-between px-2`} onClick={() => { toggleDropdown("isPlacesOpen") }}>
                <div className="fan-heading4" >
                  Places
                </div>
                {state.isPlacesOpen ? <i className="fa-solid fa-angle-up"></i> : <i className="fa-solid fa-angle-down"></i>}
              </div>
              {state.isPlacesOpen && (
                <div className="">
                  <ul className="list-unstyled m-0">
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">One Fan1 at a time
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Always exclusive
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Public message board
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Verified Public Figures </div> </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Private messages </div> </li>
                  </ul>
                </div>
              )}{" "}
            </div>
            <div className="border-bottom py-2">
              <div className={`${state.isThingsOpen && "border-bottom pb-2"} d-flex justify-content-between px-2`} onClick={() => { toggleDropdown("isThingsOpen") }}>
                <div className="fan-heading4">
                  Things
                </div>
                {state.isThingsOpen ? <i className="fa-solid fa-angle-up"></i> : <i className="fa-solid fa-angle-down"></i>}
              </div>
              {state.isThingsOpen && (
                <div className="">
                  <ul className="list-unstyled m-0">
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">One Fan1 at a time
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Always exclusive
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Public message board
                      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.6289 0.371094C15.9453 0.722656 15.9453 1.25 15.6289 1.56641L6.34766 10.8477C5.99609 11.1992 5.46875 11.1992 5.15234 10.8477L0.371094 6.06641C0.0195312 5.75 0.0195312 5.22266 0.371094 4.90625C0.6875 4.55469 1.21484 4.55469 1.53125 4.90625L5.71484 9.08984L14.4336 0.371094C14.75 0.0546875 15.2773 0.0546875 15.5938 0.371094H15.6289Z" fill="#8671FC" />
                      </svg>
                    </div>
                    </li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Verified Public Figures</div></li>
                    <li className="font-300-15 inter py-2 px-2"><div className="d-flex justify-content-between">Private messages</div></li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="learn-background-ellipses-left"></div>
        </div>

        <div className="fan-div-2 mt-80 bg-midnight learn-div-3 position-relative">
          <div className="bg-midnight">
            <h2 className="font-500-36 fan-head1">Auctions</h2>
            <p className="font-300-15">
              Fan1 uses blind auctions, where fans bid for the coveted Fan1 spot.
              At the end of the countdown the bids are tallied and ties are broken
              by the first bid in. The highest bidder wins and becomes Fan1
              immediately if their payment is successful, so bidders must use a
              valid payment method.
            </p>
          </div>

          <div className="d-block d-md-none p-4 mt-5 d-flex flex-column justify-content-around align-items-center overflow-hidden position-relative">
            {/* Next Auction Countdown */}
            <div className="px-3 px-md-5 mb-4 mb-md-0 d-flex flex-column align-items-center text-center">
              <h4 className="font-500-26 z-1 m-0 p-0 mb-2 fan-head1">
                Next Auction Countdown
              </h4>
              <p className="font-300-15 z-1 mb-3">
                Keep an eye on your favorites to see
                <br />
                when they’ll be available for auction.
              </p>
              <div className="countdown align-items-center my-auto">
                <div className="heading">Next Auction</div>
                <div className="timer font-inter-700-16 d-flex gap-2">
                  <div className="timer-block">1d</div>
                  <div className="timer-block">03h</div>
                  <div className="timer-block">12m</div>
                  <div className="timer-block">14s</div>
                </div>
                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM7.75 10.5C7.3125 10.5 7 10.8438 7 11.25C7 11.6875 7.3125 12 7.75 12H10.25C10.6562 12 11 11.6875 11 11.25C11 10.8438 10.6562 10.5 10.25 10.5H10V7.75C10 7.34375 9.65625 7 9.25 7H7.75C7.3125 7 7 7.34375 7 7.75C7 8.1875 7.3125 8.5 7.75 8.5H8.5V10.5H7.75ZM9 4C8.4375 4 8 4.46875 8 5C8 5.5625 8.4375 6 9 6C9.53125 6 10 5.5625 10 5C10 4.46875 9.53125 4 9 4Z" fill="#8671FC" />
                </svg>

              </div>
            </div>

            {/* Active Auction Countdown */}
            <div className="px-3 px-md-5 d-flex flex-column align-items-center text-center">
              <h4 className="font-500-26 z-1 m-0 p-0 mb-2 fan-head1">
                Active Auction Countdown
              </h4>
              <p className="font-300-15 z-1 mb-3">
                Cast your bid while the auction window is open. <br />
                Let the bidding begin!
              </p>
              <div className="countdown align-items-center my-auto">
                <div className="heading">
                  Auction End
                </div>
                <div className="timer font-inter-700-16 d-flex gap-2">
                  <div className="timer-block">6d</div>
                  <div className="timer-block">06h</div>
                  <div className="timer-block">22m</div>
                  <div className="timer-block">31s</div>
                </div>
                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM7.75 10.5C7.3125 10.5 7 10.8438 7 11.25C7 11.6875 7.3125 12 7.75 12H10.25C10.6562 12 11 11.6875 11 11.25C11 10.8438 10.6562 10.5 10.25 10.5H10V7.75C10 7.34375 9.65625 7 9.25 7H7.75C7.3125 7 7 7.34375 7 7.75C7 8.1875 7.3125 8.5 7.75 8.5H8.5V10.5H7.75ZM9 4C8.4375 4 8 4.46875 8 5C8 5.5625 8.4375 6 9 6C9.53125 6 10 5.5625 10 5C10 4.46875 9.53125 4 9 4Z" fill="#8671FC" />
                </svg>

              </div>

            </div>

            {/* Background Ellipses (unchanged) */}
            <div className="learn-ellipse1"></div>
            <div className="learn-ellipse2"></div>
          </div>

          <div className="my-5 row">
            <div className="col-12 col-md-6 mb-5 mb-md-0">
              <h4 className="mb-4 mb-md-1 font-500-26">For Fans</h4>
              <p className="font-300-15">
                Fans can browse available memberships, follow their favorites to
                get auction alerts, or request missing memberships.
              </p>
              <div className="d-flex flex-wrap gap-2">
                <Button className="whiteBtn py-1 px-3" label={"See Auctions"} onClick={() => { navigate("/available"); }} />
                <Button className="whiteBtn py-1 px-3" label={"Search"} onClick={handleScrollToTop}/>
                <Button
                  className="whiteBtn py-1 px-3"
                  label={"Memberships Request Form"}
                  onClick={() => handleToggle("isFavModalOpen")}
                />
              </div>
            </div>

            <div className="col-12 col-md-6">
              <h4 className="mb-4 mb-md-1 font-500-26">For Public Figures</h4>
              <p className="font-300-15">
                Your highest-bidding fan wins the exclusive Fan1 spot, and
                payouts to you are processed automatically at the end of each
                membership term.
              </p>
              <Button
                className="whiteBtn py-1 px-3"
                label="Register to Offer a Membership"
                onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}
              />
            </div>
          </div>

          <div className="learn-sub-1 p-5 bg-dark-purple mt-5 d-flex d-none d-md-flex justify-content-around position-relative overflow-hidden">
            <div className="px-5 d-flex flex-column align-items-center">
              <h4 className="font-500-26 z-1 m-0 p-0">
                Next Auction Countdown
              </h4>
              <p className="font-300-15 text-center z-1 my-3">
                Keep an eye on your favorites to see
                <br /> when they’ll be available for auction.
              </p>
              <div className="countdown align-items-center my-auto">
                <div className="heading">Next Auction</div>
                <div className="timer font-inter-700-16">
                  <div className="timer-block"> 1d </div>
                  <div className="timer-block"> 03h </div>
                  <div className="timer-block"> 12m </div>
                  <div className="timer-block"> 14s </div>
                </div>
                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM7.75 10.5C7.3125 10.5 7 10.8438 7 11.25C7 11.6875 7.3125 12 7.75 12H10.25C10.6562 12 11 11.6875 11 11.25C11 10.8438 10.6562 10.5 10.25 10.5H10V7.75C10 7.34375 9.65625 7 9.25 7H7.75C7.3125 7 7 7.34375 7 7.75C7 8.1875 7.3125 8.5 7.75 8.5H8.5V10.5H7.75ZM9 4C8.4375 4 8 4.46875 8 5C8 5.5625 8.4375 6 9 6C9.53125 6 10 5.5625 10 5C10 4.46875 9.53125 4 9 4Z" fill="#8671FC" />
                </svg>
              </div>
            </div>
            <div className="px-5 d-flex flex-column align-items-center">
              <h4 className="font-500-26 z-1 m-0 p-0">
                Active Auction Countdown
              </h4>
              <p className="font-300-15 text-center my-3">
                Cast your bid while the auction window is open. <br /> Let the
                bidding begin!
              </p>
              <div className="countdown align-items-center my-auto">
                <div className="heading">
                  Auction End
                </div>
                <div className="timer font-inter-700-16">
                  <div className="timer-block"> 00d </div>
                  <div className="timer-block"> 00h </div>
                  <div className="timer-block"> 22m </div>
                  <div className="timer-block"> 31s </div>
                </div>
                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM7.75 10.5C7.3125 10.5 7 10.8438 7 11.25C7 11.6875 7.3125 12 7.75 12H10.25C10.6562 12 11 11.6875 11 11.25C11 10.8438 10.6562 10.5 10.25 10.5H10V7.75C10 7.34375 9.65625 7 9.25 7H7.75C7.3125 7 7 7.34375 7 7.75C7 8.1875 7.3125 8.5 7.75 8.5H8.5V10.5H7.75ZM9 4C8.4375 4 8 4.46875 8 5C8 5.5625 8.4375 6 9 6C9.53125 6 10 5.5625 10 5C10 4.46875 9.53125 4 9 4Z" fill="#8671FC" />
                </svg>
              </div>

            </div>
            <div className="learn-ellipse1"></div>
            <div className="learn-ellipse2"></div>
          </div>
          <div className="learn-background-ellipses-right"></div>
        </div>

        {/*For Desktop View*/}
        <div className="fan-div-2 mt-80 bg-midnight d-none d-md-flex learn-div-4 position-relative">
          <div className="m-0 p-0 w-50">
            <div className="me-5">
              <h2 className="font-500-36 mb-3 fan-head1">Messages</h2>
              <p className="font-300-15">
                Each membership page has a public message board, where only the
                verified public figure and their current Fan1 can post. The rest
                of the world only gets to watch. Private messages are limited in
                number and seen only by the public figure and Fan1.
              </p>
            </div>
            <div className="mt-5 d-flex flex-column justify-content-between">
              <div className="mb-5 me-5">
                <h4 className="mb-3 font-500-26">For Fans</h4>
                <p className="font-300-15 me-5">
                  This is your{" "}
                  <span className="font-700-15">exclusive opportunity</span>—win
                  an auction and be the only fan who can message your idol.
                  Note that whether they respond or how frequently is up to
                  them.
                </p>
                <div>
                  <Button
                    className="whiteBtn py-1 px-3"
                    label={"Find Your Connection"}
                    onClick={() => {navigate("/available")}}
                  />
                </div>
              </div>
              <div className="">
                <h4 className="mb-3 font-500-26">For Public Figures</h4>
                <p className="font-300-15">
                  No endless DMs, just one real connection at a time.
                </p>
                <Button className="whiteBtn py-1 px-3" label={"Try It Now"} onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}/>
              </div>
            </div>
          </div>

          <div className="image-stack m-0 p-0 w-50">
            <img src={Img4} alt="" className="msg-img" />
            <img src={Img3} alt="" className="learn-imgstack" />
          </div>
          <div className="learn-background-ellipses-left-side"></div>
        </div>

        {/*For Mobile View */}
        <div className="fan-div-2 mt-80 bg-midnight d-flex flex-column d-md-none learn-div-4 position-relative">
          <div className="w-100 w-md-50 mb-4 mb-md-0">
            <div className="me-md-5 px-md-0">
              <h2 className="font-500-36 mb-3 fan-head1">Messages</h2>
              <p className="font-300-15 me-md-5">
                Each membership page has a public message board, where only the
                verified public figure and their current Fan1 can post. The rest
                of the world only gets to watch. Private messages are limited in
                number and seen only by the public figure and Fan1.
              </p>
            </div>

            <div className="w-100 w-md-50 px-md-0 custom-msg">
              <img src={img4} alt="" className="msg-img" />
            </div>

            <div className="mt-5 d-flex flex-column justify-content-between px-md-0">
              {/* Fans Section */}
              <div className="mb-5 me-md-5">
                <h4 className="mb-3 font-500-26 fan-head4">For Fans</h4>
                <p className="font-300-15 me-md-5">
                  This is your{" "}
                  <span className="font-700-15">exclusive opportunity</span>—win
                  an auction and be the only fan who can message your idol. Note
                  that whether they respond or how frequently is up to them.
                </p>
                <div>
                  <Button
                    className="whiteBtn py-1 px-3"
                    label={"Find Your Connection"}
                    onClick={() => {navigate("/available")}}
                  />
                </div>
              </div>
              {/* Public Figures Section */}
              <div>
                <h4 className="mb-3 font-500-26 fan-head4">
                  For Public Figures
                </h4>
                <p className="font-300-15">
                  No endless DMs, just one real connection at a time.
                </p>
                <Button className="whiteBtn py-1 px-3" label={"Try It Now"} onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}/>
              </div>
            </div>
          </div>
          <div className="learn-background-ellipses start-0"></div>
        </div>

        {/*Desktop View Rankings*/}
        <div className="fan-div-2 mt-80 bg-midnight d-flex learn-div-5 position-relative d-none d-md-flex">
          <div className="m-0 p-0 w-50">
            <div className="me-5">
              <h2 className="font-500-36 mb-3">Rankings</h2>
              <p className="font-300-15">
                The <span className="font-700-15">Global Rankings</span>showcase
                the highest-value Fan1 memberships. The rankings display{" "}
                <span className="font-700-15">
                  membership details, Fan1 name, countdown timers, and the
                  annualized value
                </span>{" "}
                (price paid scaled to a yearly rate).
              </p>
            </div>
            <div className="mt-5 d-flex flex-column justify-content-between">
              <div className="mb-5">
                <h4 className="mb-3 font-500-26">For Fans</h4>
                <p className="font-300-15">
                  <b>Share the spotlight</b> alongside your favorite stars in
                  the rankings.
                </p>
                <div>
                  <Button
                    className="whiteBtn py-1 px-3"
                    label={"Get Noticed"}
                    onClick={() => {navigate("/available")}}
                  />
                </div>
              </div>
              <div className="me-5">
                <h4 className="mb-3 font-500-26">For Public Figures</h4>
                <p className="font-300-15 me-5">
                  The more engaged you are, the{" "}
                  <b>higher your ranking potential</b>. Perks like{" "}
                  <b>swag, signed items, or tickets</b> can boost your bids.
                </p>
                <Button
                  className="whiteBtn py-1 px-3"
                  label={"Register Today"}
                  onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}
                />
              </div>
            </div>
          </div>

          <div className="m-0 p-0 w-50">
            <img src={Img5} alt="" className="rank-img" />
          </div>
          <div className="learn-background-ellipses-right-side"></div>
        </div>

        {/*Mobile View Rankings */}
        <div className="fan-div-2 mt-80 bg-midnight d-flex flex-column flex-md-row learn-div-5 position-relative d-md-none">
          <div className="w-100 w-md-50 mb-4 mb-md-0">
            <div className="me-md-5 px-md-0">
              <h2 className="font-500-36 mb-3 fan-head1">Rankings</h2>
              <p className="font-300-15 me-md-5">
                The <span className="font-700-15">Global Rankings</span>{" "}
                showcase the highest-value Fan1 memberships. The rankings
                display{" "}
                <span className="font-700-15">
                  membership details, Fan1 name, countdown timers, and the
                  annualized value
                </span>{" "}
                (price paid scaled to a yearly rate).
              </p>
            </div>
            <div className="w-100 w-md-50 px-md-0">
              <img src={imge5} alt="" className="rank-img" />
            </div>
            <div className="mt-5 d-flex flex-column justify-content-between px-md-0">
              <div className="mb-5">
                <h4 className="mb-3 font-500-26 fan-head4">For Fans</h4>
                <p className="font-300-15">
                  <b>Share the spotlight</b> alongside your favorite stars in
                  the rankings.
                </p>
                <div>
                  <Button
                    className="whiteBtn py-1 px-3"
                    label={"Get Noticed"}
                    onClick={() => {navigate("/available")}}
                  />
                </div>
              </div>
              <div>
                <h4 className="mb-3 font-500-26 fan-head4">
                  For Public Figures
                </h4>
                <p className="font-300-15">
                  The more engaged you are, the{" "}
                  <b>higher your ranking potential</b>. Perks like{" "}
                  <b>swag, signed items, or tickets</b> can boost your bids.
                </p>
                <Button
                  className="whiteBtn py-1 px-3"
                  label={"Register Today"}
                  onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}
                />
              </div>
            </div>
          </div>
          <div className="learn-background-ellipses end-0"></div>
        </div>

        {/*Desktop View */}
        <div className="fan-div-2 mt-80 bg-midnight d-flex learn-div-6 position-relative d-none d-md-flex overflow-hidden">
          <div className="m-0 p-0 w-50">
            <div className="me-5">
              <h2 className="font-500-36 mb-3">Your Page</h2>
              <p className="font-300-15 me-5">
                Each <span className="font-700-15">Fan1 and public figure</span>{" "}
                gets a personal page to showcase their{" "}
                <span className="font-700-15">
                  identity, achievements, and history
                </span>
                .
              </p>
            </div>
            <div className="mt-5 d-flex flex-column justify-content-between">
              <div className="mb-5 me-5">
                <h4 className="mb-3 font-500-26">For Fans</h4>
                <p className="font-300-15 me-5">
                  <b>Flaunt your Fan1 status</b>—your name is attached to every
                  membership you have.
                </p>
                <div>
                  <Button
                    className="whiteBtn py-1 px-3"
                    label={"Update Your Profile"}
                    onClick={handleClick}
                  />
                </div>
              </div>
              <div className="">
                <h4 className="mb-3 font-500-26">For Public Figures</h4>
                <p className="font-300-15">
                  Once verified, <b>your membership page is ready to go</b> on
                  your auction day.
                </p>
                <Button className="whiteBtn py-1 px-3" label={"Let's Do it"} onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}/>
              </div>
            </div>
          </div>

          <div className="image-stack m-0 p-0 w-50">
            <img src={Img6} alt="" className="page-img" />
            <img src={Img7} alt="" className="img-custom" />
            <img src={Img8} alt="" className="" />
          </div>
          <div className="learn-background-ellipses start-0"></div>
        </div>

        {/*Mobile View */}
        <div className="fan-div-2 mt-80 bg-midnight d-flex flex-column flex-md-row learn-div-6 position-relative d-md-none">
          <div className="w-100 w-md-50 px-md-0 mb-4 mb-md-0">
            <div className="me-md-5">
              <h2 className="font-500-36 mb-3 fan-head1">Your Page</h2>
              <p className="font-300-15 me-md-5">
                Each <span className="font-700-15">Fan1 and public figure</span>{" "}
                gets a personal page to showcase their{" "}
                <span className="font-700-15">
                  identity, achievements, and history
                </span>
                .
              </p>
            </div>
            {/* Images */}
            <div className="w-100 w-md-50 px-md-0 d-flex flex-column align-items-center">
              <img src={Img9} alt="" className="page-img" />
            </div>
            <div className="mt-5 d-flex flex-column justify-content-between">
              <div className="mb-5 me-md-5">
                <h4 className="mb-3 font-500-26 fan-head4">For Fans</h4>
                <p className="font-300-15 me-md-5">
                  <b>Flaunt your Fan1 status</b>—your name is attached to every
                  membership you have.
                </p>
                <div>
                  <Button
                    className="whiteBtn py-1"
                    label={"Update Your Profile"}
                    onClick={handleClick}
                  />
                </div>
              </div>
              <div className="me-md-5">
                <h4 className="mb-3 font-500-26 fan-head4">
                  For Public Figures
                </h4>
                <p className="font-300-15">
                  Once verified, <b>your membership page is ready to go</b> on
                  your auction day.
                </p>
                <Button className="whiteBtn py-1" label={"Let's Do it"} onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}/>
              </div>
            </div>
          </div>
          <div className="learn-background-ellipses start-0"></div>
        </div>

        <div className="fan-div-2 mt-80 bg-midnight d-flex flex-column align-items-center learn-div-7 position-relative">
          <h2 className="my-3 font-500-36 fan-head1">
            Ready to make Your Mark?
          </h2>
          <h3 className="my-md-4 text-center font-500-26 font-inter fan-head4">
            This is your chance to own the conversation, make history, and
            connect in ways never before possible. Whether you’re a fan or a
            public figure, Fan1 offers an exclusive, high-impact experience.
          </h3>
          <div className="col-12 mb-5 d-flex flex-column flex-md-row gap-3 justify-content-center">
            <Button
              label={"Browse Available Memberships"}
              className="font-500-20 p-3 w-md-auto"
              onClick={() => {
                navigate("/available");
              }}
            />
            <Button
              label="Register to Offer a Membership"
              className="font-500-20 p-3 yellowBtn w-md-auto"
              onClick={() => window.open("https://fan1.us/register", "_blank", "noopener,noreferrer")}
            />

          </div>
          <div className="learn-background-ellipses-left"></div>
        </div>

        {/*Desktop View */}
        <div className="overflow-hidden fan-div-2 mt-80 bg-midnight d-none d-md-flex learn-div-8 pb-0">
          <div className="m-0 p-0 w-50">
            <div className="me-5">
              <h2 className="font-500-36 mb-3">Mobile Apps coming Soon</h2>
              <p className="font-300-15 me-5 pe-5">
                Fan1 is launching dedicated mobile apps to enhance the
                experience. All bidding and purchases will still take place on
                the website for security and consistency.
              </p>
              {/* <Button
                label={"Sign up to be Notified"}
                className="font-500-20 me-3 custom-mt p-3"
                onClick={() => { }}
              /> */}
            </div>
          </div>
          <div className="m-0 p-0 w-50">
            <img src={Img2} alt="" />
          </div>
        </div>
        {/*Mobile View */}
        <div className="overflow-hidden fan-div-2 mt-80 bg-midnight d-flex d-md-none flex-column learn-div-8 pb-0">
          <div className="w-100 w-md-50 mb-4 mb-md-0 px-3 px-md-0">
            <div className="me-md-5">
              <h2 className="font-500-36 mb-3 fan-head1">
                Mobile Apps coming Soon
              </h2>
              <p className="font-300-15 me-md-5 pe-md-5">
                Fan1 is launching dedicated mobile apps to enhance the
                experience. All bidding and purchases will still take place on
                the website for security and consistency.
              </p>
              <div className="w-100 w-md-50 px-3 px-md-0 text-center">
                <img src={img2} alt="" className="img-fluid" />
              </div>
            </div>
            <div className="d-flex justify-content-center">
              {/* <Button
                label={"Sign up to be Notified"}
                className="font-500-20 custom-mt"
                onClick={() => { }}
              /> */}
            </div>
          </div>
        </div>
      </div>
      <FavRequestModal
        isVisible={state.isFavModalOpen}
        data={formData}
        onClick={handleFavRequest}
        onClose={() => handleToggle("isFavModalOpen")}
        handleInputChange={handleInputChange}
      />
    </div>
  );
};

export default LearnPage;
